import { render, staticRenderFns } from "./form-component-tree-checkbox-entry.vue?vue&type=template&id=71966f4a&scoped=true"
import script from "./form-component-tree-checkbox-entry.vue?vue&type=script&lang=ts"
export * from "./form-component-tree-checkbox-entry.vue?vue&type=script&lang=ts"
import style0 from "./form-component-tree-checkbox-entry.vue?vue&type=style&index=0&id=71966f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71966f4a",
  null
  
)

export default component.exports